<template>
  <div class="bulk-actions-left">
    <b-form-select
        @change="setBulk"
        v-model="bulkAction"
        :options="options">
    </b-form-select>
    <b-button @click="applyInBulk()" :disabled="isBusy || selectedRows.length === 0" variant="primary">{{$t('btn.apply')}}</b-button>
  </div>
</template>

<script>
export default {
  name: "BulkActionsSelect",
  props: ['options', 'value','isBusy','selectedRows'],
  data() {
    return {
      bulkAction: null
    }
  },
  methods: {
    setBulk() {
      this.$emit('bulk', this.bulkAction);
    },
    applyInBulk() {
      switch (this.bulkAction) {
        case 'delete': {
          this.$emit('bulkDeleteAction');
          break;
        }
        case 'publish': {
          this.$emit('bulkPublishAction');
          break;
        }
        case 'draft': {
          this.$emit('bulkDraftAction');
          break;
        }
        case 'export': {
          this.$emit('exportDraftAction');
          break;
        }
      }
    }
  },
  watch: {
    value: function (val) {
      this.bulkAction = val;
    }
  }
}
</script>
